module.exports = __webpack_public_path__ + "static/media/Jaiyoga.3430974a.svg";